import React, { FC } from 'react';

import { Section } from '../components/App/typescript';
import DropdownMenu from '../components/DropdownMenu/DropdownMenu';
import EventForm from '../forms/EventForm';
import { EventResource } from '../models';

import CopyMenuItem from './menuItems/CopyMenuItem';
import DestroyMenuItem from './menuItems/DestroyMenuItem';
import EventSignOutMenuItem from './menuItems/EventSignOutMenuItem';
import UpdateMenuItem from './menuItems/UpdateMenuItem';

const EventDropdownMenu: FC<{ event: EventResource }> = ({ event }) => {
  return (
    <DropdownMenu title={`Menu ${event.attributes.name}`}>
      {GLOBALS.section === Section.Main && <EventSignOutMenuItem event={event} />}
      <CopyMenuItem item={event} />
      {GLOBALS.section === Section.Admin && (
        <UpdateMenuItem form={EventForm} formLabel="Actie bewerken" resource={event} />
      )}
      {GLOBALS.section === Section.Admin && (
        <DestroyMenuItem
          redirect
          description={`Weet je zeker dat je de actie **${event.attributes.name}** wil verwijderen?`}
          resource={event}
        />
      )}
    </DropdownMenu>
  );
};

export default EventDropdownMenu;
